function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { logicalCSS } from '../../../global_styling';
import { euiFormControlDisabledStyles, euiFormControlReadOnlyStyles, euiFormControlDefaultShadow, euiFormControlInvalidStyles } from '../form.styles';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1o1b8cl-delimited",
  styles: "display:flex;label:delimited;"
} : {
  name: "1o1b8cl-delimited",
  styles: "display:flex;label:delimited;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiFormControlLayoutDelimitedStyles = function euiFormControlLayoutDelimitedStyles(euiThemeContext) {
  return {
    // Appended onto existing `euiFormControlLayout` styles
    delimited: /*#__PURE__*/css(
    // Transition smoothly between disabled/readOnly background color changes
    euiFormControlDefaultShadow(euiThemeContext, {
      withBorder: false,
      withBackground: false,
      withBackgroundAnimation: true
    }), ";label:delimited;"),
    disabled: /*#__PURE__*/css(euiFormControlDisabledStyles(euiThemeContext), ";label:disabled;"),
    readOnly: /*#__PURE__*/css(euiFormControlReadOnlyStyles(euiThemeContext), ";label:readOnly;"),
    // Appended onto existing `euiFormControlLayout__childrenWrapper` styles
    childrenWrapper: {
      delimited: _ref,
      invalid: /*#__PURE__*/css(euiFormControlDefaultShadow(euiThemeContext, {
        withBorder: false,
        withBackgroundColor: false,
        withBackgroundAnimation: false
      }), euiFormControlInvalidStyles(euiThemeContext), ";label:invalid;")
    }
  };
};
export var euiFormControlLayoutDelimited__delimiter = process.env.NODE_ENV === "production" ? {
  name: "14bhjql-euiFormControlLayoutDelimited__delimiter",
  styles: "align-self:stretch;flex-grow:0;display:flex;align-items:center;line-height:1;label:euiFormControlLayoutDelimited__delimiter;"
} : {
  name: "14bhjql-euiFormControlLayoutDelimited__delimiter",
  styles: "align-self:stretch;flex-grow:0;display:flex;align-items:center;line-height:1;label:euiFormControlLayoutDelimited__delimiter;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiFormControlLayoutDelimited__input = /*#__PURE__*/css("box-shadow:none;border:none;border-radius:0;text-align:center;", logicalCSS('height', '100%'), ";;label:euiFormControlLayoutDelimited__input;");